import { PresenceAvatarStack } from '@/components/common/PresenceAvatarStack'
import { useAnalysisPresence } from '@/hooks/useAnalysisPresence'
import { useTranslation } from '@/hooks/useTranslation'

interface AnalysisPresenceIndicatorProps {
	analysisId: string
}

export function AnalysisPresenceIndicator({ analysisId }: AnalysisPresenceIndicatorProps) {
	const viewers = useAnalysisPresence(analysisId)
	const { t } = useTranslation()

	if (viewers.length === 0) {
		return null
	}

	return (
		<PresenceAvatarStack
			viewers={viewers}
			contextLabel={t('common.presence.viewingAnalysis')}
			className="mr-1"
		/>
	)
}
